import { ReportGeneratable } from '@alberta/swodoc-document-generator';
import { AuditData } from '@alberta/swodoc-document-generator/dist/domain/Audit/Audit';

export class KeyValueGenerator implements ReportGeneratable {
  generate(data: AuditData): Promise<Buffer> {
    return data as any;
  }
}
